import { Button, Form, Image, Input, Popconfirm, Table } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { CheckCircleTwoTone, DeleteOutlined } from './Icons';
import { IMemberLicensePlate } from '@/types';
import Modal from 'antd/lib/modal/Modal';
import memberLicensePlateService from '@/services/memberLicensePlateService';
import { CDN2 } from '@/helpers/api';

interface ITableColumns {
  title: string;
  key?: string;
  align?: string;
  dataIndex?: string | string[];
  render: Function;
}

const LicensePlateModal = ({ ui, uiSet, reloadLicensePlates }) => {
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string>('');
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const add_license_plate = async (e) => {
    e.preventDefault();
    form.validateFields().then(async (values) => {
      const ret = await memberLicensePlateService.AddLicensePlate({
        licenseplate: values.licenseplate,
      } as IMemberLicensePlate);
      if (ret.status === 'OK') {
        uiSet({ ...ui, showModal: false });
        form.resetFields();
        reloadLicensePlates();
      } else {
        setConfirmLoading(false);
        setErrors(ret.error);
      }
      setConfirmLoading(false);
    });
  };

  return (
    <Modal
      visible={ui.showModal}
      title="Add License Plate"
      onOk={add_license_plate}
      closable={!confirmLoading}
      keyboard={false}
      onCancel={() => {
        if (confirmLoading) return false;
        uiSet({ ...ui, showModal: false });
      }}
      confirmLoading={confirmLoading}
    >
      <Form form={form} name="myaccount" className="w-full " scrollToFirstError>
        <Form.Item
          name="licenseplate"
          label="License Plate"
          rules={[
            {
              type: 'string',
              required: true,
              message: 'Please input your License Plate!',
            },
          ]}
          htmlFor="licenseplate"
        >
          <Input id="licenseplate" className="border border-gray-300 w-full" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default function MemberLicensePlates({ user, configInfo }) {
  const [ui, uiSet] = useState<any>({
    showModal: false,
  });
  const [keys, setKeys] = useState([] as Array<IMemberLicensePlate>);
  useEffect(() => {
    reloadLicensePlates();
  }, []);
  const reloadLicensePlates = () => {
    memberLicensePlateService.GetMemberLicensePlates().then((resp) => {
      setKeys(resp);
    });
  };

  const do_delete = async (id) => {
    await memberLicensePlateService.DeleteLicensePlate(id);
    reloadLicensePlates();
  };

  const columns: ITableColumns[] = [
    {
      title: 'License Plate',
      align: 'left',
      dataIndex: 'licenseplate',
      render: (_text, record) => (
        <div className="flex flex-row items-center">
          <Image
            src={CDN2() + '/staticmyapp/license-plate50.png'}
            width={45}
            height={45}
            alt="license plate image"
            preview={false}
          />
          <p className="mx-4">{record.licenseplate}</p>
        </div>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      render: (text, record: IMemberLicensePlate) => (
        <Popconfirm
          title="Are you sure？"
          okText="Yes"
          cancelText="No"
          onConfirm={async () => await do_delete(record.member_licenseplate_id)}
        >
          <a
            href="#"
            title="Delete this license plate"
            className="text-center mx-auto w-full"
          >
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div className="border border-primary rounded-md overflow-hidden mb-8">
      <div className="text-sm text-primary bg-orange-50 border-b border-primary  flex flex-row items-center w-full relative p-3">
        <span className="ml-2">Saved License Plates</span>
        {dayjs(user.member_dt_next_payment) > dayjs() && (
          <CheckCircleTwoTone
            className="absolute right-4 text-2xl top-2.5"
            twoToneColor="#52c41a"
          />
        )}
      </div>
      <Table
        columns={columns as []}
        dataSource={keys}
        pagination={{ style: { padding: '0 20px' } }}
      />
      <div className="p-4">
        <Button
          type="primary"
          className="uppercase"
          onClick={() => uiSet({ ...ui, showModal: true })}
        >
          Add License Plate
        </Button>
        <LicensePlateModal
          ui={ui}
          uiSet={uiSet}
          reloadLicensePlates={reloadLicensePlates}
        />
      </div>
    </div>
  );
}
